import { createFileRoute, redirect } from '@tanstack/react-router'
import Loader from '@/components/common/Loader'
import { getRoles } from '@/features/city-clerk/roles-and-permissions/api/roles-permissions-api'
import { queryKeys } from '@/lib/query-keys'
import { lazy, Suspense } from 'react'

const RolesAndPermissionsListPage = lazy(async () => {
  const module = await import(
    '@/features/city-clerk/roles-and-permissions/pages/RolesAndPermissionsListPage/RolesAndPermissionsListPage'
  )
  return { default: module.default }
})

export const Route = createFileRoute(
  '/(app)/city-clerk/roles-and-permissions/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.rolesPermissionsView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  loader: ({ context: { queryClient, auth } }) => {
    const isSuperAdmin = auth.userInfo?.uiCapabilities?.isSuperAdmin ?? false
    if (isSuperAdmin) return null

    return queryClient.fetchQuery({
      queryKey: queryKeys.roles.all,
      queryFn: () => getRoles(),
    })
  },
  component: RolesAndPermissionsPage,
})

function RolesAndPermissionsPage() {
  return (
    <Suspense
      fallback={
        <div className="h-page bg-white dark:bg-(--color-surface) rounded-lg sm:ms-6 flex items-center justify-center">
          <Loader size="lg" />
        </div>
      }
    >
      <RolesAndPermissionsListPage />
    </Suspense>
  )
}
